export default __webpack_public_path__ + "static/media/logo-white.68d04551.png";